import { render } from "./GoalsList.vue?vue&type=template&id=4872433b&ts=true"
import script from "./GoalsList.vue?vue&type=script&lang=ts"
export * from "./GoalsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__